import BulkManageMobileDrawer from "common/components/BulkManageMobileDrawer";
import type { Campaign } from "common/types";

import { MANAGE_CAMPAIGNS_ACTIONS } from "../../../constants";
import CampaignsActions from "../CampaignsActions";

interface ManageCampaignsProps {
  selectedCampaigns: Campaign[];
  resetSelectedCampaigns: () => void;
}

export default function ManageCampaigns({
  selectedCampaigns,
  resetSelectedCampaigns,
}: ManageCampaignsProps) {
  return (
    <BulkManageMobileDrawer
      drawerLabel="campaigns"
      actions={MANAGE_CAMPAIGNS_ACTIONS}
      selection={selectedCampaigns}
      renderActionComponent={({ action, onClose, onBack }) => {
        if (action) {
          return (
            <CampaignsActions
              action={action}
              selectedCampaigns={selectedCampaigns}
              onBack={onBack}
              onSuccess={() => {
                onClose();
                resetSelectedCampaigns();
              }}
            />
          );
        }
      }}
    />
  );
}
